import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import CustomTable, {TypeItemTable} from "../../components/general/CustomTable";
import {PaginationTrayResult} from "../../services/interface/trays/pagination-tray-result";
import {ListTraysApprovedMock, ListTraysDeniedMock, ListTraysPendingMock} from "../../test/mock/TraysMock";
import {CustomPagination} from "../../components/general/pagination/CustomPagination";
import {ResultTray} from "../../services/interface/trays/result-tray";
import CustomInputSearch from "../../components/general/CustomInputSearch";
import {InputValueProps} from "../../hooks/useInputValue";
import {getScore} from "../../utils/scoreOptions";
import {Tooltip} from "@material-tailwind/react";
import {formatDateHoursString} from "../../utils/daysOptions";
import {useNavigate} from "react-router";

interface Props {
    nav: string;
    search: InputValueProps;
}

export default function TableResult({nav, search}: Props) {
    const { t } = useTranslation("global") as { t: (key: string) => string };
    const header = [
        'id',
        t('score'),
        t('identification'),
        t('names'),
        t('calculate'),
        '',
    ];
    const history = useNavigate();
    const [index, setIndex] = useState<number | undefined>()
    const [list, setList] = useState<PaginationTrayResult | undefined>()
    const [listElement, setListElement] = useState<TypeItemTable[] | undefined>()

    useEffect(() => {
        if (nav) {
            switch (nav) {
                case 'approved':
                    return setList(ListTraysApprovedMock)
                case 'pending-review':
                    return setList(ListTraysPendingMock)
                case 'denied':
                    return setList(ListTraysDeniedMock)
            }
        }
    }, [nav]);

    function getPageResult(item: ResultTray) {
        history(`/result-analysis/${item.id}`)
    }

    useEffect(() => {
        if (list && list.content && list.content.length > 0) {
            const listAux: TypeItemTable[] = []
            list.content?.forEach((item: ResultTray) => {
                const score = getScore(item.score);
                listAux.push(
                    {
                        onClick: () => getPageResult(item),
                        row: [
                            item.id,
                            <div className={'flex flex-row justify-center items-center gap-2 py-1'}>
                                <div
                                    className={`flex items-center justify-center rounded-full w-[35px] h-[35px] font-bold`}
                                    style={{background: score.color}}>{item.scoreResult}</div>
                                <div className={'flex flex-col'}>
                                    <span className={'font-semibold'}>{score.score}</span>
                                    <Tooltip className={'bg-header max-w-[300px]'} content={score.description}>
                                        <span className={'truncate max-w-[200px]'}>{score.description}</span>
                                    </Tooltip>
                                </div>
                            </div>,
                            item.identification,
                            item.names,
                            <span className={'justify-center flex w-full'}>{item.calculation}</span>,
                            <div className={'flex flex-row justify-center items-center gap-2 py-1'}>
                                <div className={'flex flex-col'}>
                                    <span>{item.mail}</span>
                                    <span
                                        className={'text-gray-500 font-light'}>{formatDateHoursString(item.creationDate)}</span>
                                </div>
                            </div>,
                        ]
                    }
                )
            })
            setListElement(listAux)
        }
    }, [list]);

    return (
        <div className={'flex flex-col w-full gap-2'}>
            <CustomInputSearch onClick={() => {
            }} {...search}/>
            <CustomTable
                classNameTable={'!border border-white'}
                classNameHeader={'bg-transparent'}
                classNameItemHeader={'bg-transparent text-header !border-b-[1px] !border-blue-gray-50'}
                classNameBody={'!border border-transparent'}
                pagination={false}
                error={''}
                loading={false}
                header={header}
                {...{listElement, setIndex}}
            />
            <CustomPagination
                currentPage={list?.number}
                totalPages={list?.totalPages}
                totalElements={list?.totalElements}
                {...{setIndex}}
            />
        </div>
    )
}
